// Client-side NSFW image check (free, on-device, via NSFWJS).
//
// TF.js + NSFWJS + the model (~4MB total) are loaded lazily from a CDN the first
// time we need to check an image, so none of it is in the main bundle and it costs
// nothing until an upload actually happens (matched-photo thumbnails + avatars).
//
// FAIL-OPEN: if anything fails to load or classify, we ALLOW the image. The
// report/block/admin tools are the backstop, and we never want a CDN hiccup to
// block legitimate uploads. Self-hosting the model is a future hardening step.

const TFJS_SRC   = "https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@4.22.0/dist/tf.min.js"
const NSFWJS_SRC = "https://cdn.jsdelivr.net/npm/nsfwjs@4.2.1/dist/nsfwjs.min.js"

// Block threshold. Only the explicit categories — NOT "Sexy", which false-positives
// hard on beach/vacation photos (exactly what this app surfaces).
const BLOCK_THRESHOLD = 0.6  // Porn + Hentai combined probability

let modelPromise = null

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script")
    s.src = src
    s.onload = resolve
    s.onerror = () => reject(new Error(`failed to load ${src}`))
    document.head.appendChild(s)
  })
}

async function getModel() {
  if (modelPromise) return modelPromise
  modelPromise = (async () => {
    if (!window.tf)     await loadScript(TFJS_SRC)
    if (!window.nsfwjs) await loadScript(NSFWJS_SRC)
    const model = await window.nsfwjs.load()
    console.info("[nsfw] model loaded")
    return model
  })()
  return modelPromise
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = () => reject(new Error("image decode failed"))
    img.src = src
  })
}

// Returns true if the image (a data URL) is likely pornographic. Fail-open.
export async function isObjectionable(dataUrl) {
  if (!dataUrl) return false
  try {
    const model = await getModel()
    const img   = await loadImage(dataUrl)
    const preds = await model.classify(img)
    const score = Object.fromEntries(preds.map((p) => [ p.className, p.probability ]))
    const explicit = (score.Porn || 0) + (score.Hentai || 0)
    if (explicit > BLOCK_THRESHOLD) {
      console.warn(`[nsfw] blocked image (Porn+Hentai=${explicit.toFixed(2)})`)
      return true
    }
    return false
  } catch (e) {
    console.warn("[nsfw] check failed, allowing image:", e)
    return false
  }
}
